import JobPreviewHero from './JobPreviewHero.component';

export default JobPreviewHero;